<h2 mat-dialog-title class="m-0">Who is creating this application?</h2>

<mat-dialog-content class="adjust-for-mobile">
    <mat-form-field appearance="outline" class="max-w-300 flex-1">
        <mat-label>Staff Members</mat-label>
        <mat-select (selectionChange)="onSelectStaff($event)">
            @for (agent of agents; track $index) {
            <mat-option [value]="agent.id">{{(agent.firstName + ' ' + agent.lastName) | titlecase }}</mat-option>
            }
        </mat-select>
    </mat-form-field>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-stroked-button mat-dialog-close>Cancel</button>
</mat-dialog-actions>